import React, { FC } from "react";
import { useParams } from "react-router-dom";

import { DrillSession } from "@/features/training/pages/drill-tab/panel-right/drill-session/DrillSession";
import { TrainingDrill } from "@/features/training/pages/drill-tab/panel-right/drill/TrainingDrill";
import { UpcomingSessions } from "@/features/training/ui";
import { Box } from "@mui/material";

export const DrillPanelRight: FC = () => {
	const { drillId } = useParams();
	const { sessionId } = useParams();

	const content =
		sessionId !== undefined && drillId !== undefined ? (
			<DrillSession
				sessionId={parseInt(sessionId)}
				drillId={parseInt(drillId)}
			/>
		) : drillId !== undefined ? (
			<TrainingDrill id={parseInt(drillId)} />
		) : (
			<UpcomingSessions type={"drill"} />
		);

	return (
		<Box
			data-tour="training-drills-right"
			sx={{
				flex: 1,
				minHeight: 0,
				display: "flex",
				flexDirection: "column",
				overflow: "hidden",
			}}
		>
			{content}
		</Box>
	);
};
